import * as React from "react"
import { useQuery } from "react-query"
import { Box, Center, Divider, Spinner } from "@chakra-ui/react"
import { NotificationSettings } from "../components/NotificationSettings"
import { ApiSettings } from "../components/ApiSettings"
import { OrgEntity } from "../lib/types/org"
import { ORGS_IS_GOOGLE } from "../lib/static/organisation"
import { useMe } from "./providers/MeProvider"
import { isAdmin } from "../lib/helpers/role"

export interface OrgPrefsResponse {
  uuid: string
  allowed_email_alert_types: string[]
  uses_payments: boolean
}

interface SettingsTabProps {
  organization: OrgEntity
}

export const SettingsTab = ({ organization }: SettingsTabProps) => {
  const me = useMe()

  const { data, isLoading } = useQuery<OrgPrefsResponse, string>(
    `organizations/${organization.uuid}/preference/`,
    { staleTime: Infinity },
  )

  if (isLoading) {
    return (
      <Center h={400}>
        <Spinner />
      </Center>
    )
  }

  if (data) {
    return (
      <Box pt={6}>
        {!ORGS_IS_GOOGLE([organization]) && (
          <NotificationSettings
            organization={organization}
            allowedEmailAlertTypes={data.allowed_email_alert_types}
          />
        )}
        <Divider my={8} />
        {/* <PaymentsAccountSettings organization={organization} usesPayments={data.uses_payments} />
        <Divider my={8} /> */}
        {isAdmin(me.roles, organization.url) && <ApiSettings organization={organization} />}
      </Box>
    )
  }

  return null
}
